import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Gallery from './pages/Gallery';
import Astrology from './pages/Astrology';
import Parents from './pages/Parents';
import Wishlist from './pages/Wishlist';
import Events from './pages/Events';
import Diary from './pages/Diary';
import Guestbook from './pages/Guestbook';
import './App.css';

function App() {
  return (
    <div className="app">
      <Header />
      <main className="main">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/astrology" element={<Astrology />} />
          <Route path="/parents" element={<Parents />} />
          <Route path="/wishlist" element={<Wishlist />} />
          <Route path="/events" element={<Events />} />
          <Route path="/diary" element={<Diary />} />
          <Route path="/guestbook" element={<Guestbook />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default App; 